require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/fn/object/keys.js
// module id = 962
// module chunks = 0 1